import React from "react";
import { useNavigate } from "react-router-dom";
import { MapPinIcon, PhoneXMarkIcon, UserIcon } from "@heroicons/react/24/outline";
import { useMeeting } from "../../contexts/MeetingContext";
import useRingingSound from "../../hooks/useRingingSound";

const MeetingRequestModal = () => {
  const navigate = useNavigate();
  const { meetingRequest, acceptMeeting, rejectMeeting } = useMeeting();

  useRingingSound(!!meetingRequest);

  if (!meetingRequest) return null;

  const { meetingId, from, creator } = meetingRequest;
  const displayName = creator?.firstName
    ? [creator.firstName, creator.lastName].filter(Boolean).join(" ")
    : "A user";

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
        <div className="fixed inset-0 bg-black bg-opacity-60 transition-opacity backdrop-blur-sm"></div>

        <div className="inline-block align-bottom bg-white rounded-2xl text-left overflow-hidden shadow-2xl transform transition-all sm:my-8 sm:align-middle sm:max-w-md sm:w-full">
          <div className="bg-gradient-to-r from-blue-500 to-blue-600 px-6 py-8 text-center">
            <div className="w-20 h-20 bg-white bg-opacity-20 rounded-full flex items-center justify-center mx-auto mb-4">
              <MapPinIcon className="h-10 w-10 text-white" />
            </div>
            <h3 className="text-xl font-semibold text-white mb-1">
              {displayName}
            </h3>
            <p className="text-blue-100 text-sm">Wants to share live location</p>
          </div>

          <div className="p-6">
            <div className="flex justify-center space-x-6">
              <button
                onClick={() => rejectMeeting(meetingId, from)}
                className="flex flex-col items-center p-4 rounded-full bg-red-100 hover:bg-red-200 text-red-700 transition-colors"
              >
                <PhoneXMarkIcon className="h-8 w-8" />
                <span className="text-xs mt-1 font-medium">Decline</span>
              </button>
              <button
                onClick={() => {
                  acceptMeeting(meetingId, from);
                  navigate(`/meeting/${meetingId}`);
                }}
                className="flex flex-col items-center p-4 rounded-full bg-blue-100 hover:bg-blue-200 text-blue-700 transition-colors"
              >
                <MapPinIcon className="h-8 w-8" />
                <span className="text-xs mt-1 font-medium">Accept</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MeetingRequestModal;
